import React from "react";
import "./chubb_pa_series_c.css";

/**
 * Chubb — PA Series C (Plan 1–8 + Kid)
 * Zero-index safe: ไม่มี {index} ใน JSX และคีย์ map มาจากข้อมูลจริง
 * → เติมตัวเลขจากเอกสาร Series C ลงในอาร์เรย์ด้านล่างได้ทันที
 */

const fmt = (x) =>
  x === null || x === undefined ? "—" : typeof x === "number" ? x.toLocaleString() : x;

const PLANS = ["แผน 1","แผน 2","แผน 3","แผน 4","แผน 5","แผน 6","แผน 7","แผน 8","บุตร Kid"];

// ===== ผลประโยชน์ต่อแผน (กรอกตามตารางในภาพ Series C) =====
const benefits = [
  { key: "life",    name: "1. อุบัติเหตุทั่วไป (ชีวิต/สูญเสียอวัยวะ/ทุพพลภาพถาวร)", vals: [100000,200000,300000,500000,700000,1000000,2000000,3000000,50000] },
  { key: "murder",  name: "1.2 ฆาตกรรม/ทำร้ายร่างกาย",                        vals: [100000,200000,300000,500000,700000,1000000,2000000,3000000,50000] },
  { key: "moto",    name: "1.3 อุบัติเหตุรถจักรยานยนต์",                       vals: [50000,100000,150000,250000,350000,500000,1000000,1500000,25000] },
  { key: "terror",  name: "1.4 การก่อการร้าย",                                  vals: [0,0,0,0,0,0,0,0,0] }, // ถ้าไม่มีคุ้มครอง ให้เว้น 0/เครื่องหมาย "—"
  { key: "holiday", name: "1.5–1.6 วันหยุดสาธารณะ/พาหนะสาธารณะ (เพิ่มทุน)",   vals: [100000,200000,300000,500000,700000,1000000,2000000,3000000,50000] },
  { key: "funeral", name: "2. ค่าปลงศพ (เหตุอุบัติเหตุ)",                      vals: [20000,20000,20000,20000,20000,20000,20000,20000,5000] },
  { key: "income",  name: "3. รายได้ระหว่างหยุดงาน (สูงสุด 12 เดือน) *ถ้ามี",   vals: [/* กรอก */] },
  { key: "med",     name: "4. ค่ารักษาพยาบาลต่อครั้ง (รวมมอเตอร์ไซค์)",        vals: [10000,20000,30000,50000,70000,100000,100000,100000,5000] },
  { key: "hap",     name: "5–8 HAP/Smart Money/ICU/ฯลฯ (ถ้ามีในชุดแผน)",        vals: [/* กรอกหรือลบแถวนี้ถ้าไม่มี */] },
];

// ===== เบี้ยรายปี (รวมอากร/แสตมป์) — PA1 และ PA2 (ตัวเลขตามตารางบริเวณท้ายเอกสาร) =====
const premiums = {
  PA1: [
    { key: "main",   label: "ผู้เอาประกันหลัก (PA1)",                     vals: [1150,1650,2050,2950,3750,4250,7250,9550,null] },
    { key: "spouse", label: "ผู้เอาประกัน + คู่สมรส (PA1)",                 vals: [2250,3250,3950,5750,7350,8250,14510,18650,null] },
    { key: "kids2",  label: "ผู้เอาประกัน + บุตร ≤ 2 คน (PA1)",             vals: [3150,3650,4050,4950,5750,6250,9250,11550,null] },
    { key: "kids3",  label: "ผู้เอาประกัน + บุตร ≤ 3 คน (PA1)",             vals: [4250,5150,6150,7750,9350,10650,16150,20550,null] },
  ],
  PA2: [
    { key: "main",   label: "ผู้เอาประกันหลัก (PA2)",                     vals: [1450,2050,2550,3550,4550,5150,8750,11550,null] },
    { key: "spouse", label: "ผู้เอาประกัน + คู่สมรส (PA2)",                 vals: [2550,3550,3950,5650,7150,8050,13950,18500,null] },
    { key: "kids2",  label: "ผู้เอาประกัน + บุตร ≤ 2 คน (PA2)",             vals: [3550,4150,4550,5450,6350,7050,11950,15950,null] },
    { key: "kids3",  label: "ผู้เอาประกัน + บุตร ≤ 3 คน (PA2)",             vals: [4550,5250,5850,6850,8150,9150,13850,19350,null] },
  ],
};

export default function ChubbPASeriesCDetails({ onQuote }) {
  return (
    <div className="pkg-detail chubb-pa-c">
      <h2>Chubb PA Series C — แผน 1–8 + Kid</h2>
      <p className="pkg-note">
        อายุรับ 15–70 ปี ต่ออายุได้ถึง 75 ปี • เด็ก 6 เดือน–23 ปี (ตามเงื่อนไข) •
        เลือกเดี่ยว/คู่สมรส/ครอบครัว • เบี้ยรวมอากรแสตมป์
      </p>

      {/* ผลประโยชน์ต่อแผน */}
      <h3 className="pkg-section">ผลประโยชน์ต่อแผน</h3>
      <table className="pkg-table">
        <thead>
          <tr>
            <th className="pkg-left">ความคุ้มครอง</th>
            {PLANS.map((p) => <th key={`plan-${p}`}>{p}</th>)}
          </tr>
        </thead>
        <tbody>
          {benefits.map((b) => (
            <tr key={`bf-${b.key}`}>
              <td className="pkg-left">{b.name}</td>
              {(b.vals || []).map((v, i) => <td key={`bf-${b.key}-${i}`}>{fmt(v)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>

      {/* PA1 */}
      <h3 className="pkg-section">เบี้ยรายปี (PA1)</h3>
      <table className="pkg-table">
        <thead>
          <tr>
            <th className="pkg-left">รูปแบบผู้เอาประกัน</th>
            {PLANS.map((p) => <th key={`pa1h-${p}`}>{p}</th>)}
          </tr>
        </thead>
        <tbody>
          {premiums.PA1.map((row) => (
            <tr key={`pa1-${row.key}`}>
              <td className="pkg-left">{row.label}</td>
              {row.vals.map((v, i) => <td key={`pa1-${row.key}-${i}`}>{fmt(v)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>

      {/* PA2 */}
      <h3 className="pkg-section">เบี้ยรายปี (PA2)</h3>
      <table className="pkg-table">
        <thead>
          <tr>
            <th className="pkg-left">รูปแบบผู้เอาประกัน</th>
            {PLANS.map((p) => <th key={`pa2h-${p}`}>{p}</th>)}
          </tr>
        </thead>
        <tbody>
          {premiums.PA2.map((row) => (
            <tr key={`pa2-${row.key}`}>
              <td className="pkg-left">{row.label}</td>
              {row.vals.map((v, i) => <td key={`pa2-${row.key}-${i}`}>{fmt(v)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>

      <ul className="pkg-bullets">
        <li>Kid = บุตรอายุ 6 เดือน–23 ปี (ตามเงื่อนไขบริษัท)</li>
        <li>โปรดตรวจสอบข้อยกเว้นและอาชีพที่ไม่รับก่อนเสนอขาย</li>
      </ul>

      <div className="pkg-foot">
        <button className="pkg-quote-btn" onClick={onQuote} aria-label="ขอใบเสนอราคา Chubb PA Series C">
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
